export default __webpack_public_path__ + "static/char-v-34-zh-Hant-51e5d77c8d73430ba3f2af6ad8294735.mp4";